<script setup>
  defineOptions({
    name: "DashboardHeroImage",
  });
</script>

<template>
  <div class="min-h-44 shadow-md md:h-104">
    <img
      class="size-full object-cover object-top-left"
      src="@images/hero-image-large.jpg"
      alt="Pharmazeutische Dienstleistung Amts"
    />
  </div>
</template>
